import { ANNOTATION_TARGETS } from 'constants';
import { PopAnnotation } from './pop';
import { AdjacentPopAnnotation } from './pop/adjacent';
import { ImageAnnotation } from './image';
import { AdjacentImageAnnotation } from './image/adjacent';
import { ChapterMenuAnnotation } from './chapter_menu/chapter_menu_annotation';
import { OnTimeAnnotation } from './on_time_annotation';
import { ControlsAnnotation } from './controls';
import { ClosedCaptionsAnnotation } from './closed_captions';
import { IframeAnnotation } from './iframe';
import { AdjacentIframeAnnotation } from './iframe/adjacent';
import { ISIAnnotation } from './isi';
import { DrawingAnnotation } from './drawing';
import { HotlinkAnnotation } from './hotlink';
import { MuteToggle } from './mute_toggle/mute_toggle';
import { ContentExplorer } from './content_explorer';
import { Bookmark } from './bookmark';
import { BranchSelector } from './branch_selector';
import { InfoPanel } from './info_panel';
import { Stylesheet } from './stylesheet';
import { FormAnnotation } from './form';
import { AdjacentFormAnnotation } from './form/adjacent';
import { LanguageProvider } from './language_provider';
import { VideoAnnotation } from './video';
import { VideoText } from './video_text';
import { QuizAnnotation } from './quiz/quiz';
import { AdjacentQuizAnnotation } from './quiz/adjacent';
import { SmartCaptionsAnnotation, AdjacentSmartCaptionsAnnotation } from './smart_captions';
import { ActivitiesPanel } from './activities_panel';
import { AudioAnnotation } from './audio';
import { AudioDescriptionAnnotation } from './audio_description';
import { ConditionalSettingsProvider } from './conditional_settings_provider';
import { DefinitionProvider } from './definition_provider'
import { Phantom } from './phantom';

export const ANNOTATION_COMPONENT_MAP = {
    image: ImageAnnotation,
    pop: PopAnnotation,
    iframe: IframeAnnotation,
    contents: ChapterMenuAnnotation,
    ontime: OnTimeAnnotation,
    isi: ISIAnnotation,
    controls: ControlsAnnotation,
    closedcaptions: ClosedCaptionsAnnotation,
    drawing: DrawingAnnotation,
    hotlink: HotlinkAnnotation,
    mute: MuteToggle,
    contentexplorer: ContentExplorer,
    bookmark: Bookmark,
    branchselector: BranchSelector,
    infopanel: InfoPanel,
    stylesheet: Stylesheet,
    form: FormAnnotation,
    languageprovider: LanguageProvider,
    video: VideoAnnotation,
    videotext: VideoText,
    quiz: QuizAnnotation,
    smartcaptions: SmartCaptionsAnnotation,
    activitiespanel: ActivitiesPanel,
    audiotrack: AudioAnnotation,
    audiodescription: AudioDescriptionAnnotation,
    conditionalsettingsprovider: ConditionalSettingsProvider,
    definitionprovider: DefinitionProvider,
    phantom: Phantom
};

export const ADJACENT_COMPONENT_MAP = {
    ...ANNOTATION_COMPONENT_MAP,
    iframe: AdjacentIframeAnnotation,
    image: AdjacentImageAnnotation,
    form: AdjacentFormAnnotation,
    pop: AdjacentPopAnnotation,
    quiz: AdjacentQuizAnnotation,
    smartcaptions: AdjacentSmartCaptionsAnnotation
};

export const EXTERNAL_COMPONENT_MAP = {
    ...ADJACENT_COMPONENT_MAP
}

export const getComponentMap = (target = '') => (
    target === 'player' ?
        ANNOTATION_COMPONENT_MAP : (
            target.startsWith('adjacent') ?
                ADJACENT_COMPONENT_MAP :
                EXTERNAL_COMPONENT_MAP
        )
)